import React from "react";
import numeral from "numeral";

const defaultFormat = "0.0a";

export default class NumberLabel extends React.PureComponent {
  render() {
    const { className, params, isSpan, ...retProps } = this.props;

    let numberClass = styles.number;

    if (className) {
      numberClass += " " + className;
    }

    let num = this.props.children;
    let format = params && params.format ? params.format : defaultFormat;

    if (params) {
      if (params.precision) {
        let zeroes = "0".repeat(params.precision);
        format = format.substr(0, format.indexOf(".") + 1) + zeroes + "a";
      }
    }

    return (
      <React.Fragment>
        {typeof num == "number" ? (
          isSpan ? (
            <span {...retProps} className={numberClass}>
              {numeral(num).format(format)}
            </span>
          ) : (
            <div {...retProps} className={numberClass}>
              {numeral(num).format(format)}
            </div>
          )
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}
